import { useState } from 'react';

const TimePickerField = ({ value = '', label, handleChange, ...props }) => {
  const [time, setTime] = useState(value);
  return (
    <div className="">
      <label className="block mb-2 font-bold">{label}</label>
      <input
        className="border border-gray-300 px-4 py-2 rounded-md"
        type="time"
        value={time}
        onChange={(event) => {
          setTime(event.target.value);
          handleChange(event.target.value);
        }}
        {...props}
      />
    </div>
  );
};

export default TimePickerField;
